export default "__VITE_ASSET__BjTNmFcY__"